export const FAKE_DOOR_WIZARD_SOURCE = 'fakedoor';
export const MARKETING_PLANNER_FEEDBACK_COMMENT_MAX_LENGTH = 200;

export enum MarketingPlannerState {
  ACTIVE = 'active',
  COLLAPSED = 'collapsed',
  HIDDEN = 'hidden',
}

export enum MarketingPlannerItemType {
  POST = 'post',
  PROMPT_PILL = 'prompt_pill',
  EXPERIMENT = 'experiment',
}

export enum MarketingPlannerFeedbackType {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  SUGGESTION = 'suggestion',
}

export enum MarketingPlannerNegativeFeedbackPreset {
  DOESNT_FIT_BUSINESS = 'doesnt_fit_business',
  TIMING_NOT_RIGHT = 'timing_not_right',
  ALREADY_DONE = 'already_done',
  POST_OUTDATED = 'post_outdated',
  RATHER_MAKE_NEW = 'rather_make_new',
  OTHER = 'other',
}

export interface MarketingPlannerFeedback {
  itemType: MarketingPlannerItemType;
  itemKey: string | null;
  feedbackType: MarketingPlannerFeedbackType;
  negativeFeedbackPreset?: MarketingPlannerNegativeFeedbackPreset;
  comment?: string;
}

export interface MarketingPlannerPost {
  /** The recommended social media post's id (`publishingdb.social_media_post.idpost`). */
  postId: string;
  title: string;
  whyPost: string;
  previewUrl: string;
  lastPublishedOn: number | null;
}

/** The unwrapped success payload of `socialmedia/duplicatePostAsDraft`. */
export interface DuplicatePostAsDraftResponse {
  idPost: string;
  post: unknown;
}

export interface MarketingPlannerPromptPill {
  emoji: string;
  label: string;
  prompt: string;
}

export interface MarketingPlannerProps {
  state: MarketingPlannerState;
  businessName: string | null;
  primaryVertical: string;
  posts: MarketingPlannerPost[];
  promptPills: MarketingPlannerPromptPill[];
}
